var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"fixed top-0 left-0 w-screen h-screen flex items-center justify-center"},[_vm._m(0)]):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-container"},[_c('img',{staticClass:"loader-logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":"Dr. Manisha's Yoga Institute logo"}})])
}]

export { render, staticRenderFns }